import React, { Component } from 'react'
import Link from 'gatsby-link'
import {SlideAdvanceArea} from './slide-advance-area'

import './slide.css'

class Slide extends Component {

  createRightAdvanceArea() {
    return (
      <div className = "left-half">
        <SlideAdvanceArea
          href = {this.props.href}
          isLeftAdvance = {true}
          onAdvance={this.props.onAdvanceLeft}></SlideAdvanceArea>
      </div>
    );
  }

  createLeftAdvanceArea() {
    return (
      <div className = "right-half">
        <SlideAdvanceArea
          href = {this.props.href}
          isLeftAdvance = {false}
          onAdvance={this.props.onAdvanceRight}></SlideAdvanceArea>
      </div>
    );
  }

  render () {
    let leftAdvanceArea = (this.props.canAdvanceLeft ? this.createLeftAdvanceArea() : null);
    let rightAdvanceArea = (this.props.canAdvanceRight ? this.createRightAdvanceArea() : null);

    return (
      <div>
        {leftAdvanceArea}
        {rightAdvanceArea}
      </div>
    );
  }
}


export default {Slide}



// WEBPACK FOOTER //
// ./src/components/Slide/slide.js